import { useCallback, useRef, useState } from 'react';

/**
 * Verrou de soumission pour les actions payantes. Le drapeau d'état ne suffit pas : deux clics
 * émis dans le même cycle de rendu le lisent tous les deux à `false`. Seule la référence, mise à
 * jour de façon synchrone, bloque le second.
 */
export function useSubmitLock() {
  const lockedRef = useRef(false);
  const [isLocked, setIsLocked] = useState(false);

  const runExclusive = useCallback(async (task: () => Promise<void>) => {
    if (lockedRef.current) return;
    lockedRef.current = true;
    setIsLocked(true);
    try {
      await task();
    } finally {
      lockedRef.current = false;
      setIsLocked(false);
    }
  }, []);

  return { isLocked, runExclusive };
}
